export default {
  GET_STRIPE_SESSION: 'GET_STRIPE_SESSION',
  CANCEL_SUB: 'CANCEL_SUB',
  REACTIVATE_SUB: 'REACTIVATE_SUB',
  UPGRADE_COST: 'UPGRADE_COST',
  UPGRADE: 'UPGRADE',
};
